// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1CompanySchema } from './v1/companySchema';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnprocessableEntityErrorSchema } from './v1/unprocessableEntityErrorSchema';

export const exportClientToIntegrationPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("AppUser id"),
});

export const exportClientToIntegrationQueryParamsSchema = z.object({
  client_id: z.optional(z.number().int().describe("Timely client id to export")),
}).optional();

export const exportClientToIntegrationHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Client exported
 */
export const exportClientToIntegration200Schema = z.lazy(() => v1CompanySchema);

/**
 * @description Forbidden - Insufficient permissions
 */
export const exportClientToIntegration403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description Client not found
 */
export const exportClientToIntegration404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Unprocessable Entity - Export error
 */
export const exportClientToIntegration422Schema = z.lazy(() => v1UnprocessableEntityErrorSchema);

export const exportClientToIntegrationMutationResponseSchema = z.lazy(() => exportClientToIntegration200Schema);
